export let IntegrationSource = /*#__PURE__*/function (IntegrationSource) {
  IntegrationSource["Qbo"] = "qbo";
  IntegrationSource["FinancialCents"] = "financial-cents";
  IntegrationSource["Karbon"] = "karbon";
  return IntegrationSource;
}({});